<script>
    // @ts-nocheck
    import { fade, scale } from 'svelte/transition'
    import { API_URL } from '$lib/conf'
    import { navigate } from 'svelte-navigator'
    import { Frame } from '$lib/components/layout'
    import {
        DatosProveedor,
        InformacionImpositiva,
        InformacionLaboral,
        AcreditacionCuenta,
    } from '$lib/components/forms'
    import TerminosCondiciones from '$lib/custom/components/TerminosCondiciones.svelte'
    import {
        Form,
        Button,
        Track,
        Spinner,
        Alert,
        Typography,
        StepperWidget as Stepper,
    } from '$lib/components/UI/'
    import DocumentationSelector from '$lib/custom/components/DocumentationSelectorX.svelte'
    import { fakeFetch, areEquals, regexEmail } from '$lib/utils'
    import Result from '$lib/components/UI/Result.svelte'
    export let uuid
    let formData
    let validForm
    let current
    let loading = false
    let state
    let data = {}
    let initialData = structuredClone(data)
    let replaceDocs = []
    let taxConditions = {}
    let documents = []
    let providerSiniestros = true
    let terminos = false
    let objContainer
    const fetchData = fetch(`${API_URL}/status/${uuid}`)
        // const fetchData = fakeFetch({resolveValue: {
        //   state: 'Solicitud de Informacion Compras',
        //   comment: 'Cambiar el CUIT',
        //   update: {
        //     cbu_ac: '',
        //     banco_ac: '007'
        //   },
        //   tax_conditions: {
        //     condicion_imp_iva_ii: '5',
        //     condicion_imp_ganancias_ii: '5',
        //     condicion_imp_ingresos_ii: '1'
        //   },
        //   replace_docs: [
        //     {
        //       title: '<Nombre de la doc>',
        //       id: '555555555555',
        //       activa: '',
        //       proveedor_migrado: '',
        //       siniestros: '',
        //       denominacion: '',
        //       cuit: '',
        //       fecha_emision: '2024-08-05',
        //       fecha_vencimiento: '',
        //       tipo_documentacion: '',
        //       jurisdiccion: '',
        //       impuesto: 'IVA',
        //       observacion: ''
        //     }
        //   ]
        // }, umbral: 1})
        .then(async (res) => {
            if (res.ok) {
                let ret = await res.json()
                data = ret.update
                initialData = structuredClone(data)
                taxConditions = ret.tax_conditions
                replaceDocs = ret.replace_docs || []
                state = ret.state
                return ret
            } else {
                throw Error('404')
            }
        })
        .catch((e) => {
            throw Error('404')
        })

    async function sendData() {
        loading = true
        // fakeFetch({resolveValue: {}, umbral: 1})
        await fetch(`${API_URL}/provider/${uuid}`, {
            method: 'PUT',
            body: JSON.stringify({ ...data, documents: documents.filter(d => 'files' in d) }),
        })
        .then((res) => {
            if (res.ok) {
                console.log({ data, documents })
                navigate('/result', {
                    state: {
                        title: '¡Listo!',
                        desc: 'Se modificó correctamente su información.',
                        icon: 'mailPositive',
                    },
                })
            }
        })
        .catch(err => {
            loading = false
            console.log(err)
        })
        .finally(() => {loading = false})
    }
    const states = [
        {
            label: 'Validación de datos',
            states: [
                'Ingresado',
                'Mesa Proveedores',
                'Control de Gestion',
                'Compras',
                'Cuentas a Pagar',
                'Solicitud de Informacion Compras',
                'Solicitud de Informacion Cuentas a Pagar',
                'Impuestos',
            ],
            desc: 'Estamos validando tus datos. Pronto recibirá un mail confirmando su habilitación.',
        },
        {
            label: 'Validación info. impositiva',
            states: [
                'Tesoreria',
                'Impuestos',
                'Solicitud de Informacion Tesoreria',
                'Solicitud Impuestos Prov',
                'Solicitud Control de Gestion Prov',
                'Revision Mesa Proveedores CG',
                'Revision Mesa Proveedores IMP',
                'Revision Mesa Proveedores TES',
                'Solicitud Informacion Prov',
                'Solicitud Tesoreria Prov',
            ],
            desc: 'Estamos validando sus datos impositivos',
        },
        {
            label: 'Habilitación',
            states: ['Habilitado'],
            desc: 'El proceso de alta finalizó correctamente, por favor verifique su casilla de correo para conocer el resultado.',
        },
    ]

    $: if (state)
        current = (function () {
            let res = 0
            states.forEach((st, i) => {
                if (st.states.includes(state)) {
                    res = i
                }
            })
            return res
        })()
    let currentStep, allowBack, allowNext
    let validSection = false
    // console.clear()

    let currentSectionSuffix = ''

    function extractFieldsBySuffix(data, suffix) {
        return Object.fromEntries(
            Object.entries(data).filter(([k]) =>
                new RegExp(`^.*_${suffix}$`, 'i').test(k)
            )
        )
    }

    function sectionChange(a, b, suffix) {
        let sectionOrg = extractFieldsBySuffix(a, suffix)
        let section = extractFieldsBySuffix(b, suffix)
        // console.log({sectionOrg, section, suffix})
        return !areEquals(section, sectionOrg)
    }
    
    let validSections = ['dp', 'ii', 'ac', 'doc'].reduce((r, c) => ({...r, [c]: null}), {})

    $: sectionHasChange = sectionChange(data, initialData, currentSectionSuffix)
    $: showDoc =
        [
            'condicion_imp_iva_ii',
            'condicion_imp_ganancias_ii',
            'condicion_imp_ingresos_ii',
        ].some((k) => k in data) || replaceDocs?.length > 0
    $: validSection = currentSectionSuffix ? validSections[currentSectionSuffix] : validSections.doc || false
    $: validSendData = validSection && !loading
</script>

<Frame title="Estado de solicitud">
    <div class="formulario">
        {#await fetchData}
            <div class="space" transition:scale>
                <Spinner />
            </div>
        {:then dataf}
            {#if state.match(/^Sol.+/) && ((dataf.update && Object.keys(dataf.update).length > 0) || replaceDocs.length > 0)}
                <!-- <Form bind:valid={validForm} bind:data={formData}> -->
                {#if dataf.comment}
                    <Alert style="width: 100%" type="warning"
                        >{@html dataf.comment.replace(
                            /\n|\\n/g,
                            '<br/>'
                        )}</Alert
                    >
                {/if}
                <Stepper.Group bind:currentStep bind:allowBack bind:allowNext>
                    {#if Object.keys(dataf.update).some( (x) => x.match(/^.+_dp$/) )}
                        <Stepper.Step
                            label="Datos del Proveedor"
                            on:load={() => {
                                currentSectionSuffix = 'dp'
                            }}
                        >
                            <span in:fade={{ duration: 700 }}>
                                <DatosProveedor
                                    {providerSiniestros}
                                    bind:valid={validSections.dp}
                                    inputs={Object.keys(dataf.update)}
                                    bind:data
                                />
                            </span>
                        </Stepper.Step>
                    {/if}
                    {#if Object.keys(dataf.update).some( (x) => x.match(/^.+_ii$/) )}
                        <Stepper.Step
                            label="Información Impositiva"
                            on:load={() => {
                                currentSectionSuffix = 'ii'
                            }}
                        >
                            <span in:fade={{ duration: 700 }}>
                                <InformacionImpositiva
                                    {providerSiniestros}
                                    showDoc={false}
                                    bind:valid={validSections.ii}
                                    inputs={Object.keys(dataf.update)}
                                    bind:data
                                />
                            </span>
                        </Stepper.Step>
                    {/if}
                    <!-- {#if Object.keys(dataf.update).some(x => x.match(/^.+_lp$/))}
              <Stepper.Step label="Información Laboral" on:load={() => {currentSectionSuffix = 'lp';}}>
                <span in:fade={{duration: 700}}>
                  <InformacionLaboral {providerSiniestros} bind:valid={validSection} inputs={Object.keys(dataf.update)} bind:data />
                </span>
              </Stepper.Step>
            {/if} -->
                    {#if Object.keys(dataf.update).some( (x) => x.match(/^.+_ac$/) )}
                        <Stepper.Step
                            label="Acreditación de Cuenta"
                            on:load={() => {
                                currentSectionSuffix = 'ac'
                            }}
                        >
                            <span in:fade={{ duration: 700 }}>
                                <AcreditacionCuenta
                                    {providerSiniestros}
                                    bind:valid={validSections.ac}
                                    inputs={[...Object.keys(dataf.update)]}
                                    bind:data
                                />
                            </span>
                        </Stepper.Step>
                    {/if}
                    <!-- <br/> -->
                    {#if showDoc}
                        <Stepper.Step label="Documentación" on:load={() => {currentSectionSuffix = null}}>
                            <span in:fade={{ duration: 700 }}>
                                <DocumentationSelector
                                    bind:value={documents}
                                    bind:valid={validSections.doc}
                                    providerData={data}
                                    docs={replaceDocs}
                                    taxConf={taxConditions}
                                />
                            </span>
                        </Stepper.Step>
                    {/if}
                    <span class="footer" slot="footer">
                        {#if allowBack}
                            <Button
                                disabled={!allowBack}
                                on:click={() => {
                                    currentStep -= 1
                                }}>Atrás</Button
                            >
                        {/if}
                        {#if !allowNext}
                            <Button
                                on:click={() => (terminos = true)}
                                disabled={!validSendData}
                                label="Enviar información"
                            />
                        {:else}
                            <Button
                                disabled={!(
                                    allowNext &&
                                    validSection &&
                                    sectionHasChange
                                )}
                                on:click={() => {
                                    currentStep += 1
                                }}>Siguiente</Button
                            >
                        {/if}
                    </span>
                </Stepper.Group>
                <!-- </Form> -->
            {:else}
                <Track
                    {current}
                    breakPoints={states.map((x) => {
                        return { label: x.label }
                    })}
                />
                <Result type="neutral">
                    <Typography style="text-align: center" type="h3"
                        >{states[current].desc}</Typography
                    >
                    <Typography type="body">RequestId: {uuid}</Typography>
                </Result>
            {/if}
        {/await}
    </div>
</Frame>
<TerminosCondiciones
    show={terminos}
    buttonLabel="Enviar información"
    on:send={sendData}
/>

<style>
    .formulario {
        max-width: 1000px;
        width: 100%;
        position: relative;
        background: var(--color-white);
        padding: 25px;
        margin: auto;
    }
    .space {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
    .footer {
        display: flex;
        flex-direction: columns;
        justify-content: space-between;
        align-items: center;
    }
</style>
